import React from "react";
import { Plus, RefreshCw, CalendarDays, List, MapPin, UserRound, Layers } from "lucide-react";
import { SERVICES } from "../../../lib/services";
import { AppointmentCard, DolibarrEventCard } from "./AppointmentCards";

const levelTag = (u) => {
  if (u.level === "major") return " (major)";
  if (u.level === "superadmin") return " (admin)";
  return "";
};

export const AgendaToolbar = ({ view, setView, who, setWho, service, setService, team, onNavigate, onReload, onNew }) => {
  const tab = (v) => `flex items-center gap-1.5 px-3 py-1.5 ${view === v ? "bg-brand text-white" : "text-neutral-600 hover:bg-neutral-100"}`;
  return (
    <div className="flex items-center justify-between mb-5">
      <h2 className="font-heading font-bold text-xl text-neutral-900">Agenda</h2>
      <div className="flex items-center gap-3">
        <div className="flex rounded-md border border-neutral-300 overflow-hidden text-sm">
          <button onClick={() => setView("calendar")} data-testid="agenda-view-calendar" className={tab("calendar")}><CalendarDays size={14} /> Calendrier</button>
          <button onClick={() => setView("list")} data-testid="agenda-view-list" className={tab("list")}><List size={14} /> Liste</button>
        </div>
        <label className="flex items-center gap-1.5 text-sm text-neutral-600">
          <Layers size={14} />
          <select value={service} onChange={(e) => setService(e.target.value)} data-testid="agenda-filter-service" className="border border-neutral-300 rounded-md px-2 py-1.5 text-sm bg-white">
            <option value="">Tous les services</option>
            {Object.entries(SERVICES).map(([k, s]) => <option key={k} value={k}>{s.label}</option>)}
          </select>
        </label>
        <label className="flex items-center gap-1.5 text-sm text-neutral-600">
          <UserRound size={14} />
          <select value={who} onChange={(e) => setWho(e.target.value)} data-testid="agenda-filter-member" className="border border-neutral-300 rounded-md px-2 py-1.5 text-sm bg-white">
            <option value="">Toute l'équipe</option>
            {team.map((u) => <option key={u.login} value={u.login}>{u.nom}{levelTag(u)}</option>)}
          </select>
        </label>
        {onNavigate && (
          <button onClick={() => onNavigate("interventions")} data-testid="agenda-new-intervention-btn" className="flex items-center gap-1.5 text-sm text-neutral-700 hover:text-brand border border-neutral-300 px-3 py-1.5 rounded-md"><MapPin size={14} /> Planifier une intervention</button>
        )}
        <button onClick={onReload} className="flex items-center gap-1.5 text-sm text-neutral-600 hover:text-brand"><RefreshCw size={15} /> Actualiser</button>
        <button onClick={onNew} data-testid="appointment-new-btn" className="flex items-center gap-2 bg-brand hover:bg-brand-dark text-white text-sm font-semibold px-4 py-2 rounded-md"><Plus size={16} /> Nouveau RDV</button>
      </div>
    </div>
  );
};

const DolibarrList = ({ doli }) => {
  if (doli.error) return <p className="text-sm text-amber-600">Dolibarr indisponible : {doli.error}</p>;
  if (doli.events.length === 0) return <p className="text-neutral-500 text-sm">Aucun événement dans l'agenda Dolibarr.</p>;
  return <div className="space-y-3">{doli.events.map((e) => <DolibarrEventCard key={e.id} e={e} />)}</div>;
};

export const AgendaListView = ({ visible, appts, prospects, doli, onRemove }) => {
  const prospectName = (id) => prospects.find((p) => p.id === id)?.societe || "—";
  return (
    <div className={visible ? "grid lg:grid-cols-2 gap-6" : "hidden"}>
      <div>
        <h3 className="font-semibold text-neutral-800 mb-3">Rendez-vous CRM</h3>
        {appts.length === 0
          ? <p className="text-neutral-500 text-sm">Aucun rendez-vous planifié.</p>
          : <div className="space-y-3">{appts.map((a) => <AppointmentCard key={a.id} a={a} prospectName={prospectName(a.prospect_id)} onRemove={onRemove} />)}</div>}
      </div>
      <div>
        <h3 className="font-semibold text-neutral-800 mb-3">Agenda Dolibarr</h3>
        <DolibarrList doli={doli} />
      </div>
    </div>
  );
};
